import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "nge-patch",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Rare cell type spotted"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-patch-beam",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-patch-scan",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "nge-patch-brk tl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "nge-patch-brk tr",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "nge-patch-brk bl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "nge-patch-brk br",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "nge-patch-row nge-patch-head",
  style: {"--i":"0"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-patch-pumpkin",
    "aria-hidden": "true"
  }, "🎃"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-patch-tag" }, "Field report"),
    /*#__PURE__*/_createElementVNode("span", { class: "nge-patch-title" }, "Rare cell type spotted!")
  ])
], -1 /* HOISTED */)
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "nge-patch-pips-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "nge-patch-row nge-patch-text",
  style: {"--i":"2"}
}, [
  /*#__PURE__*/_createTextVNode(" Proofreaders in the Sandbox report a "),
  /*#__PURE__*/_createElementVNode("b", null, "jack o' lantern neuron"),
  /*#__PURE__*/_createTextVNode(". Only ever seen in October. ")
], -1 /* HOISTED */)
const _hoisted_12 = {
  class: "nge-patch-row nge-patch-btns",
  style: {"--i":"3"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "nge-patch-backdrop",
      onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($setup.emit('no')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("button", {
          class: "nge-patch-x",
          "aria-label": "Close",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('no')))
        }, "×"),
        _hoisted_8,
        _createElementVNode("div", {
          class: "nge-patch-row nge-patch-pips",
          style: {"--i":"1"},
          title: `${$setup.sightings} sightings`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sightings, (n) => {
            return (_openBlock(), _createElementBlock("i", {
              key: n,
              class: "nge-patch-pip",
              style: _normalizeStyle({ '--n': n })
            }, null, 4 /* STYLE */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("span", _hoisted_10, _toDisplayString($setup.sightings) + " sightings", 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_9),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createCommentVNode(" Smash the pumpkins (Ames 2026-10-25): off to the patch with a\n               hammer; smashed pumpkins stay off until the chat bar's pumpkin\n               button brings them back (util/pumpkin.ts). "),
          _createElementVNode("button", {
            class: "nge-patch-hide",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.emit('smash')))
          }, "🔨 Smash the pumpkins"),
          _createElementVNode("button", {
            class: "nge-patch-no",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.emit('toggle')))
          }, _toDisplayString($setup.hidden ? 'Show the pumpkin' : 'Hide the pumpkin'), 1 /* TEXT */),
          _createElementVNode("button", {
            ref: "yesEl",
            class: "nge-patch-yes",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.emit('yes')))
          }, "Go to the patch", 512 /* NEED_PATCH */)
        ])
      ])
    ])
  ]))
}